import Ajv from 'ajv'
import addFormats from 'ajv-formats'
import ajvErrors from 'ajv-errors'
import ajvKeywords from 'ajv-keywords'
import _ from 'lodash'
import { isStringNumber, isPhoneCode } from '..'

/* -------------------------------------------------------------------------- */
/*                                   Initial                                  */
/* -------------------------------------------------------------------------- */
export const ajv = new Ajv({
  allErrors: true,
  removeAdditional: true,
  useDefaults: true,
  coerceTypes: true,
})
addFormats(ajv) // https://ajv.js.org/packages/ajv-formats.html
ajvErrors(ajv) // https://ajv.js.org/packages/ajv-errors.html
ajvKeywords(ajv) // https://ajv.js.org/packages/ajv-keywords.html

/* -------------------------------------------------------------------------- */
/*                                   Format                                   */
/* -------------------------------------------------------------------------- */
ajv.addFormat('isStringNumber', isStringNumber)
ajv.addFormat('isPhoneCode', isPhoneCode)

/* -------------------------------------------------------------------------- */
/*                                   Keyword                                  */
/* -------------------------------------------------------------------------- */

/* -------------------------------------------------------------------------- */
/*                                  Validator                                 */
/* -------------------------------------------------------------------------- */
/**
 * @param {Record<string, any>} schema
 * @param {Record<string, any>} data
 * @param {boolean} flatten
 * @return {{ valid: boolean; errors: Record<string, any> | string[] }}
 */
export const customValidator = (schema, data, flatten = false) => {
  const validate = ajv.compile(schema)
  const valid = validate(data)
  let errors = []

  if (!valid) {
    validate.errors.forEach((error) => {
      const parameter = error.instancePath?.length
        ? error.instancePath.slice(error.instancePath.lastIndexOf('/') + 1)
        : error.params.missingProperty
      const errorMessage = `'${parameter}' ${error.message}`
      errors.push({ parameter, message: errorMessage })
    })
  }

  if (flatten) {
    errors = _.map(errors, (error) => error.message)
  }

  return { valid, errors }
}

export const validator = (schema, data, flatten = false) => {
  const validate = ajv.compile(schema)
  const valid = validate(data)
  let errors = []

  if (!valid) {
    validate.errors.forEach((error) => {
      if ('instancePath' in error && error.instancePath.length) {
        const parameter = error.instancePath.slice(error.instancePath.lastIndexOf('/') + 1)
        errors.push({ parameter, message: error.message })
      }
    })
  }

  if (flatten) {
    errors = _.map(errors, (error) => error.message)
  }

  return { valid, errors }
}
/**
 * @param {string[]} errors
 * @param {Record<string, string>} changeParamsTo
 * @returns {string[]}
 */
export const changeValidatorParams = (errors, changeParamsTo) => {
  const keys = Object.keys(changeParamsTo)
  let errorText = errors.join('∆ƒß')
  for (const key of keys) {
    errorText = errorText.replace(`'${key}'`, changeParamsTo[key])
  }

  return errorText.split('∆∑ß')
}

/**
 * @param {Record<string, any>} schema
 * @param {Record<string, any>} data
 * @param {Record<string, string>} changeParamsTo
 * @return {{ valid: boolean; errors: Record<string, any> }}
 */
export const flatValidation = (schema, data, changeParamsTo) => {
  const { valid, errors } = customValidator(schema, data, true)
  const changedErrors = changeValidatorParams(errors, changeParamsTo)
  return { valid, errors: changedErrors }
}
